var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59375 8.76562C1.59375 10.6677 2.34936 12.4919 3.69434 13.8369C5.03933 15.1819 6.86353 15.9375 8.76562 15.9375C10.6677 15.9375 12.4919 15.1819 13.8369 13.8369C15.1819 12.4919 15.9375 10.6677 15.9375 8.76562C15.9375 6.86353 15.1819 5.03933 13.8369 3.69434C12.4919 2.34936 10.6677 1.59375 8.76562 1.59375C6.86353 1.59375 5.03933 2.34936 3.69434 3.69434C2.34936 5.03933 1.59375 6.86353 1.59375 8.76562Z",
    stroke: "#657789",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8369 13.8359L17.5312 17.5302",
    stroke: "#657789",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.83c8cefba233c81101c1490758a07946.svg";
export { ForwardRef as ReactComponent };